export default __webpack_public_path__ + "static/media/pt-grey.b2d6dc12.svg";